import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { MaterialImports } from '@environments/environment';
import { CustomFormsModule } from '@app/modules/forms.module';
import { FormsModule } from '@angular/forms';
import { EventDetailComponent } from '@components/eventdetail.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [EventDetailComponent],
  exports: [EventDetailComponent],
  imports: [CommonModule, UtilsModule, SharedModule, MaterialImports, RouterModule, CustomFormsModule, FormsModule, NgxSkeletonLoaderModule],
})
export class EventDetailsModule {}
